import React from 'react';
import { DialogContent, DialogTitle } from '@mui/material';
import ModalComponent from '../ModalComponent';
import ModalCloseButton from './ModalCloseButton';
import ModalDialogActions from './ModalDialogActions';
import { MODAL_STYLES } from '../../utils/modalStyles';
import styles from '../ModalComponent/modalStyles.module.css';

/**
 * Standardized modal wrapper that provides consistent structure and styling
 * Combines ModalComponent, title, close button, content, and actions
 *
 * @param {boolean} open - Whether the modal is open
 * @param {function} handleClose - Function to close the modal
 * @param {string} title - Modal title
 * @param {React.ReactNode} children - Modal content
 * @param {React.ReactNode} actions - Modal actions (buttons)
 * @param {object} dialogContentSx - Custom styling for DialogContent
 * @param {boolean} dividers - Whether to show dividers (default: true)
 * @param {boolean} showCloseButton - Whether to show close button (default: true)
 */
export default function ModalWrapper({
  open,
  handleClose,
  title,
  children,
  actions,
  dialogContentSx = {},
  dividers = true,
  showCloseButton = true,
}) {
  const contentSx = {
    ...MODAL_STYLES.dialogContent,
    ...dialogContentSx,
  };

  return (
    <ModalComponent open={open} handleClose={handleClose}>
      <div className={styles.modal}>
        <DialogTitle sx={MODAL_STYLES.dialogTitle}>
          {title}
        </DialogTitle>

        {showCloseButton && <ModalCloseButton onClick={handleClose} />}

        <DialogContent dividers={dividers} sx={contentSx}>
          {children}
        </DialogContent>

        {actions && (
          <ModalDialogActions>
            {actions}
          </ModalDialogActions>
        )}
      </div>
    </ModalComponent>
  );
}